export default __webpack_public_path__ + "static/6-f6887b33316d3583fedf53e92090fdc1.png";